/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import ToastNotification from "./ToastNotification";
import BannerNotification from "./BannerNotification";
import Styles from "./index.css";

const NotificationView = props => {
  const {
    intl,
    notifications,
    notificationBanners,
    closeToastNotification,
    closeBannerNotification,
    viewPortHeight,
    setNotificationHeight,
    getNotificationHeight,
    getNotificationBannerHeight,
    setNotificationBannerHeight,
    shouldUseMobileModernViewer,
    isFullScreenMode,
    getCurrentNotificationBannerHeight,
    renderBannerBeforeDocView
  } = props;

  let style;
  if (isFullScreenMode) {
    style = {
      display: "none"
    };
  }

  const containerClassName = renderBannerBeforeDocView ? Styles.FixedContainer : Styles.Container;

  return (
    <div className={containerClassName} style={style}>
      {notifications.map((ele, index) => {
        const { id, msg } = ele;
        const { overrideClassName, variant, actionLabel, onAction, overrideParentStyle } = ele.options;
        const previewViewPortHeight = renderBannerBeforeDocView
          ? viewPortHeight + getCurrentNotificationBannerHeight()
          : viewPortHeight;
        return (
          <ToastNotification
            overrideClassName={overrideClassName}
            intl={intl}
            msg={msg}
            variant={variant}
            closeNotification={() => closeToastNotification(id)}
            index={index}
            actionLabel={actionLabel}
            onAction={onAction}
            viewPortHeight={previewViewPortHeight}
            notificationHeight={getNotificationHeight(id)}
            setNotificationHeight={setNotificationHeight}
            id={id}
            shouldUseMobileModernViewer={shouldUseMobileModernViewer}
            overrideParentStyle={overrideParentStyle}
          />
        );
      })}
      {notificationBanners.map((ele, index) => {
        const { id, msg } = ele;
        const { overrideClassName, variant, actionLabel, onAction, closeOnAction, messageIcon } = ele.options;
        return (
          <BannerNotification
            overrideClassName={overrideClassName}
            intl={intl}
            msg={msg}
            variant={variant}
            closeNotification={() => closeBannerNotification(id)}
            index={index}
            actionLabel={actionLabel}
            onAction={onAction}
            closeOnAction={closeOnAction}
            notificationBannerHeight={getNotificationBannerHeight(id)}
            setNotificationBannerHeight={setNotificationBannerHeight}
            id={id}
            shouldUseMobileModernViewer={shouldUseMobileModernViewer}
            messageIcon={messageIcon}
            renderBannerBeforeDocView={renderBannerBeforeDocView}
          />
        );
      })}
    </div>
  );
};

export default NotificationView;
